import { apiDelete, apiGet } from "../../../API/Service/apiClient";
  
export const handleGet_supplierPartyList = async ({
  setLoading,
  filter,
  setDataList,
  setFilteredList,
  showAlert,
  setTotalRecords,setTotalPages,
}) => {
  setLoading(true);
  try {
    const resData = await apiGet("supplier-party-data", filter || {});
    setDataList(resData?.data)
    setFilteredList(resData?.data)
    setTotalRecords(resData?.totalCount)
    setTotalPages(resData?.totalPages)
  } catch (err) {
    showAlert({
      title: "Error",
      message: err?.message || "Something went wrong. Please try again.",
      type: "error",
      confirmLabel: "Ok",
    });
  } finally {
    setLoading(false);
  }
};

export const handleDelete_supplierPartyList = async({
  setActionLoading,data,showAlert,setFilteredList,setDataList
})=>{    
  setActionLoading({delId:data?.id})  
  try {    
    const resData =await apiDelete("supplier-party-data",data);     
     if(resData?.data > 0){
      showAlert({
        title: "Success",
        message: "Record deleted successfully",
        type: "success",
        confirmLabel: "Ok",
        cancelLabel: "Cancel", 
        showCancel: false,         
        onConfirm:()=>{          
          setFilteredList((prevList) => prevList.filter((item) => item.id !== data?.id));
          setDataList((prevList) => prevList.filter((item) => item.id !== data?.id));          
        }
      });
      
     }else{
      showAlert({
        title: "Error?",
        message: "Something went wrong. Please try again later.",
        type: "error",
        confirmLabel: "Ok",
        cancelLabel: "Cancel", 
        showCancel: false,         
      });
     }
  } catch (error) {
    showAlert({
      title: "Error?",
      message: "Oops! Something went wrong. Please try again later.",
      type: "error",
      confirmLabel: "Ok",
      cancelLabel: "Cancel", 
      showCancel: false,         
    });
  }finally{
    setActionLoading({})
  }
}